import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { TbX } from "react-icons/tb";
import { useEscKey } from "src/hooks/useEscKey";
import { OnboardingChecklist } from "./OnboardingChecklist";

/** Standalone Getting Started popup — reachable any time from the dashboard button. */
export function GettingStartedPopup({ onClose }: { onClose: () => void }) {
    const { t } = useTranslation();
    useEscKey(onClose, true);
    return createPortal(
        <div className="onboarding-overlay" onClick={onClose}>
            <div className="onboarding-modal onboarding-modal--standalone onboarding-modal--checklist" onClick={(e) => e.stopPropagation()}>
                <div className="onboarding-modal__header">
                    <h2 className="onboarding-modal__title">{t("onboarding.gettingStartedTitle")}</h2>
                    <button className="onboarding-modal__close" onClick={onClose}><TbX /></button>
                </div>
                <p className="onboarding-modal__desc">{t("onboarding.gettingStartedDesc")}</p>
                <OnboardingChecklist />
                <div className="onboarding-modal__nav">
                    <button type="button" className="onboarding-modal__btn onboarding-modal__btn--primary" onClick={onClose}>
                        {t("popup.done")}
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
}
